import { TabContext } from '@mui/lab'
import { Tab, Tabs, styled } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'

type OrdersTabsProps = {
  className?: string
  value: string
  setValue: Dispatch<SetStateAction<string>>
}

export interface StyledTabsProps {
  children?: React.ReactNode
  value: string
  onChange: (event: React.SyntheticEvent, newValue: string) => void
  className?: string
  variant?: 'standard' | 'scrollable' | 'fullWidth' | undefined
  scrollButtons?: boolean
  allowScrollButtonsMobile?: boolean
}

export const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{ children: <span className='MuiTabs-indicatorSpan' /> }} />
))(({ theme }) => ({
  color: '#6A6A6A',
  minHeight: 36,
  height: 36,
  marginRight: 0,
  [(theme as any).breakpoints.up('md')]: {
    marginRight: '40px',
    marginLeft: 0,
  },
  backgroundColor: 'white',
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: 4,
  },
  '& .MuiTabs-indicatorSpan': {
    backgroundColor: 'none',
  },
}))

export interface StyledTabProps {
  label: string
  id: string
  value: string
  'aria-controls': string
  onHover?: () => void
}

export const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} onMouseEnter={props.onHover} />
))(({ theme }) => ({
  minWidth: 0,
  minHeight: 36,
  height: 36,
  paddingRight: 10,
  paddingLeft: 10,
  marginRight: '20px',
  textAlign: 'center',
  textTransform: 'none',
  // fontWeight: theme.typography.fontWeightRegular,
  color: '#6A6A6A',
  fontSize: 14,
  fontWeight: 500,

  ':hover': {
    color: '#000000',
  },
  '&.Mui-selected': {
    color: '#2196F3',
    borderBottom: '3px solid #2196F3',
    fontWeight: 'bold',
    ':hover': {
      color: '#0069D9',
      borderColor: '#0069D9',
    },
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#983FF1',
  },
}))

export function OrdersTabs(props: OrdersTabsProps) {
  const { className, value, setValue } = props
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }
  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  })

  const tabItems = ['ACTIVE', 'HISTORY', 'CANCELED']
  return (
    <div className={`w-full ${className}`}>
      <TabContext value={value}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          className='md:ml-10'
          variant='scrollable'
          scrollButtons
          allowScrollButtonsMobile
        >
          {tabItems?.map((category, index) => (
            <StyledTab label={category} {...a11yProps(index)} value={index.toString()} />
          ))}
        </StyledTabs>
      </TabContext>
    </div>
  )
}
